import React,{useEffect} from 'react'
import Adminfooter from '../Shared/Adminfooter'
import Adminnavbar from '../Shared/Adminnavbar'
import Adminsidebar from '../Shared/Adminsidebar'
import { useNavigate } from 'react-router-dom'

function Admindashboard() {
  const navigate = useNavigate();
    useEffect(() => {
       const token = sessionStorage.getItem("tokenadmin");

      if (!token) {
        navigate("/admin-login"); 
        return;
      }
    })
  return (
    <>
        <div class="container-scroller">
        <Adminnavbar />
        <div class="container-fluid page-body-wrapper">
          <Adminsidebar />
          <div class="main-panel">
            <div class="content-wrapper">
              <section class="content-header mb-5">
                <h3 class="content-header-text">
                   WELCOME, Admin
                </h3>

                <h3></h3>
              </section>
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
               
                </div>
                <div class="col-md-1"></div>
              </div>
            </div>
            <Adminfooter />
          </div>
        </div>
      </div>
    </>
  )
}

export default Admindashboard